import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomTypography } from "src/components/ui/Typography";
import { CustomButton } from "src/components/ui/Button";
import { cn } from "src/util/cn";
import type { CustomButtonProps } from "src/components/ui/Button";

export interface CustomTitleSectionProps {
  titleKey: string;
  level?: 1 | 2 | 3 | 4;
  classNameContainer?: string;
  titleClassName?: string;
  buttonKey?: string;
  onClick?: () => void;
  to?: string;
  buttonType?: CustomButtonProps["type"];
  buttonSize?: CustomButtonProps["buttonSize"];
  danger?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  buttonProps?: Omit<CustomButtonProps, "children" | "type" | "buttonSize" | "danger" | "disabled" | "icon" | "onClick">;
  showBtn?: boolean;
  rightBtnComponent?: React.ReactNode;
}

const CustomTitleSection: React.FC<CustomTitleSectionProps> = ({
  titleKey,
  level = 2,
  classNameContainer,
  titleClassName,
  buttonKey,
  onClick,
  to,
  buttonType = "primary",
  buttonSize = "medium",
  danger = false,
  disabled = false,
  icon,
  buttonProps,
  showBtn = true,
  rightBtnComponent,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) navigate(to);
    else onClick?.();
  };

  return (
    <div className={cn("flex items-center justify-between gap-4", classNameContainer)}>
      <CustomTypography.CustomTitle level={level} className={titleClassName}>
        {t(titleKey)}
      </CustomTypography.CustomTitle>
      <div className="flex items-center gap-2">
        {rightBtnComponent}
        {showBtn && (buttonKey || onClick || to) && (
          <CustomButton
            type={buttonType}
            buttonSize={buttonSize}
            danger={danger}
            disabled={disabled}
            icon={icon}
            onClick={handleClick}
            {...buttonProps}
          >
            {buttonKey ? t(buttonKey) : undefined}
          </CustomButton>
        )}
      </div>
    </div>
  );
};

export default memo(CustomTitleSection);
